<template>
  <div class="birthday-select questionnaire-fixed-width">
    <div class="bir-area-select">
      <select v-model="birthdatData.year" @change="setYear" class="year-select select" :style="option">
        <option
          v-for="item in yearList"
          :value="item"
          :key="item"
          class="select-option"
        >{{ item }}</option>
      </select>
      <span class="select-label" :style="cascaderLabelStyle">年</span>
    </div>
    <div class="bir-area-select">
      <select v-model="birthdatData.month" @change="setMonth($event)" class="month-select select" :style="option">
        <option
          v-for="item in monthList"
          :value="item"
          :key="item"
          class="select-option"
        >{{ item }}</option>
      </select>
      <span class="select-label" :style="cascaderLabelStyle">月</span>
    </div>
    <div class="bir-area-select">
      <select v-model="birthdatData.day" @change="setDay($event)" class="day-select select" :style="option">
        <option
          v-for="item in dayList"
          :value="item"
          :key="item"
          class="select-option"
        >{{ item }}</option>
      </select>
      <span class="select-label" :style="cascaderLabelStyle">日</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DataSelect',
  props: ['birthdayInfo', 'option', 'isHidingMinors', 'cascaderLabelStyle'],
  data() {
    return {
      monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      birthdatData: {
        year: null,
        month: null,
        day: null,
      },
    };
  },
  computed: {
    curDay() {
      return this.birthdatData.day;
    },
    // 获取Day
    dayList() {
      const monthRange = this.getMonthDay(this.birthdatData.year, this.birthdatData.month);
      console.log('monthRange', this.birthdatData, monthRange);
      return this.getNumberArr(1, monthRange);
    },
    // 获取年份
    yearList() {
      let currentYear = new Date().getFullYear();
      if (this.isHidingMinors) {
        currentYear = currentYear - 18;
      }
      console.log('currentYear', currentYear);
      return this.getYearArr(1900, currentYear);
    },
  },
  watch: {
    birthdayInfo(val) {
      console.log('val', val);
      this.birthdatData = val;
      console.log('this.birthdatData', this.birthdatData);
    },
  },
  methods: {
    getNumberArr(a, b) {
      return Array.from(Array(b - a + 1)).map((e, i) => a + i);
    },
    getYearArr(a, b) {
      return Array.from(Array(b - a + 1)).map((e, i) => a + i)
        .reverse();
    },
    getMonthDay(year, month) {
      const days = new Date(year, month, 0).getDate();
      return days;
    },
    setYear() {
      if (!this.birthdatData.month) {
        this.birthdatData.month = null;
        if (!this.birthdatData.day) {
          this.birthdatData.day = null;
        }
      }
      this.birthdatData.day = null;
      this.birthdatData.month = null;
      this.$emit('setBirthDay', this.birthdatData);
    },
    setMonth(e) {
      if (!e.target.value) {
        return;
      }
      if (!this.birthdatData.year) {
        this.birthdatData.month = null;
        return this.alert('请先选择年份!');
      }
      this.birthdatData.day = null;
      this.$emit('setBirthDay', this.birthdatData);
    },
    setDay(e) {
      if (!e.target.value) {
        return;
      }
      if (!this.birthdatData.year) {
        this.birthdatData.day = null;
        return this.alert('请先选择年份!');
      }
      if (!this.birthdatData.month) {
        this.birthdatData.day = null;
        return this.alert('请先选择月份!');
      }
      this.$emit('setBirthDay', this.birthdatData);
    },
  },
};
</script>
<style lang="scss" scoped>
.birthday-select {
  display: flex;
  align-items: center;
}

.bir-area-select {
  position: relative;
  display: flex;
  align-items: center;
}

.bir-area-select::after {
  position: absolute;
  display: block;
  right: 0.2rem;
  top: 65%;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0.15rem 0.1rem;
  border-color: #000 transparent transparent transparent;
  transform: translate(0, -50%);
  transform: translate(0, -50%);
  transform: translate(0, -50%);
  transform: translate(0, -50%);
  transform: translate(0, -50%);
  pointer-events: none;
}

.select {
  width: 100%;
  background: #f0f0f0;
  border: 0;
  // height: 0.6rem;
  text-align: center;
  font-size: 0.26rem;
  color: #000;
  appearance: none;
  display: block;
  outline: none;
}

.select::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 0;
}

.select::-webkit-scrollbar {
  appearance: none;
  width: 5px;
  height: 5px;
}

.select::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.15);
  transition: color 0.2s ease;
}

.select::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.2);
}

.select::-webkit-scrollbar-track {
  width: 0.5px;
  border-radius: 0px;
  background: rgba(0, 0, 0, 0.2);
}

.year-select {
  // width: 1rem;
}

.month-select {
  // width: 1rem;
}

.select-label {
  margin: 0 5px;
}

.day-select {
  // width: 1rem;
}

.select-option {
  text-align: center;
}
</style>
